import { Typography } from "@mui/material";

export const SandboxText = () => (
  <Typography color="textSecondary" marginLeft={1} component="span" noWrap>
    (Sandbox)
  </Typography>
);
